import { render, staticRenderFns } from "./4.vue?vue&type=template&id=36b36432&scoped=true&"
import script from "./4.vue?vue&type=script&lang=js&"
export * from "./4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b36432",
  null
  
)

export default component.exports